import { Pipe, PipeTransform } from '@angular/core';
import { MyProfile } from './my-profile.pipe';

@Pipe({
  name: 'isPostCollaborator'
})
export class isPostCollaboratorPipe implements PipeTransform {
  constructor(private readonly myProfilePipe: MyProfile) {}

  transform(
    collaboratingCreatory: {
      permission: string;
      email: string;
      user_name: string;
    }[],
    userName?,
    checkPermission: boolean = false
  ): boolean {
    if (Array.isArray(collaboratingCreatory)) {
      for (const collab of collaboratingCreatory) {
        const value = userName ? collab?.user_name : collab?.email;
        if (
          (checkPermission || collab?.permission == 'true') &&
          this.myProfilePipe.transform(value, userName)
        ) {
          return true;
        }
      }
    }
    return false;
  }
}
